let dropdownLoaded = false

class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.render()
  }

  setupListeners () {
    super.setupListeners()

    this.handleDropdownMouseEnter = this.handleDropdownMouseEnter.bind(this)
    this.handleDropdownMouseLeave = this.handleDropdownMouseLeave.bind(this)
    this.handlePanelFocusOut = this.handlePanelFocusOut.bind(this)
    this.handleToggleClick = this.handleToggleClick.bind(this)

    this.submenus.forEach((submenu) => {
      this.listeners.add(
        submenu.dropdown,
        'mouseenter',
        this.handleDropdownMouseEnter,
      )
      this.listeners.add(
        submenu.dropdown,
        'mouseleave',
        this.handleDropdownMouseLeave,
      )
      this.listeners.add(submenu.panel, 'focusout', this.handlePanelFocusOut)
      this.listeners.add(submenu.toggle, 'click', this.handleToggleClick)
    })
  }

  /** @param {PointerEvent} event */
  handleDropdownMouseEnter (event) {
    const id = event.currentTarget.dataset.dropdownId
    const submenu = this.submenus.find((submenu) => submenu.id === id)

    this.toggleSubmenu(submenu, true)
  }

  /** @param {PointerEvent} event */
  handleDropdownMouseLeave (event) {
    const id = event.currentTarget.dataset.dropdownId
    const submenu = this.submenus.find((submenu) => submenu.id === id)

    this.toggleSubmenu(submenu, false)
  }

  /** @param {FocusEvent} event */
  handlePanelFocusOut (event) {
    const id = event.currentTarget.id
    const submenu = this.submenus.find((submenu) => submenu.id === id)

    const focusIsStillInPanel = submenu.panel.contains(event.relatedTarget)

    if (focusIsStillInPanel) {
      return
    }

    this.toggleSubmenu(submenu, false)
  }

  /** @param {PointerEvent} event */
  handleToggleClick (event) {
    const id = event.currentTarget.getAttribute('aria-controls')
    const submenu = this.submenus.find((submenu) => submenu.id === id)

    this.toggleSubmenu(submenu, !submenu.isVisible)
  }

  /**
   * @param {HeaderDropdown['submenus'][number]} activeSubmenu
   * @param {boolean} force
   */
  toggleSubmenu (activeSubmenu, force) {
    this.submenus.forEach((submenu) => {
      const isVisible = submenu.id === activeSubmenu.id ? force : false

      submenu.toggle.setAttribute('aria-expanded', isVisible)
      submenu.panel.setAttribute('aria-hidden', !isVisible)
    })
  }

  render () {
    if (dropdownLoaded) return

    const SECTION = 'header'

    window.BAO.sectionRenderer
      .fetch(SECTION, `${window.Shopify.routes.root}?view=dropdown`)
      .then((res) => {
        dropdownLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(res[SECTION])
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }

  get submenus () {
    if (!this.els.dropdown || !this.els.toggle || !this.els.panel) {
      return []
    }

    /** @type {HTMLElement[]} */
    const dropdowns = this.els.dropdown?.elements ?? []
    /** @type {HTMLElement[]} */
    const panels = this.els.panel?.elements ?? []
    /** @type {HTMLElement[]} */
    const toggles = this.els.toggle?.elements ?? []

    return dropdowns.map((dropdown) => {
      const id = dropdown.dataset.dropdownId
      const panel = panels.find((panel) => panel.id === id)
      const toggle = toggles.find(
        (toggle) => toggle.getAttribute('aria-controls') === id,
      )

      return {
        dropdown,
        id,
        isVisible: panel.getAttribute('aria-hidden') === 'false',
        panel,
        toggle,
      }
    })
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
